export const categories = [
  {
    slug: 'dianshiju',
    name: '电视剧',
    description: '精选国产电视剧，涵盖都市情感、历史古装、悬疑刑侦等多种类型',
    icon: 'ri-tv-line',
    imageSeq: 'cat-dianshiju',
  },
  {
    slug: 'dianying',
    name: '电影',
    description: '国产电影佳作，从文艺片到商业大片，一网打尽',
    icon: 'ri-film-line',
    imageSeq: 'cat-dianying',
  },
  {
    slug: 'zongyi',
    name: '综艺',
    description: '热门国产综艺节目，音乐竞演、真人秀、脱口秀应有尽有',
    icon: 'ri-mic-line',
    imageSeq: 'cat-zongyi',
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    description: '高质量国产纪录片，探索中国自然风光、人文历史与科技发展',
    icon: 'ri-camera-line',
    imageSeq: 'cat-jilupian',
  },
  {
    slug: 'dongman',
    name: '动漫',
    description: '国产原创动漫作品，国风美学与现代叙事的完美融合',
    icon: 'ri-paint-brush-line',
    imageSeq: 'cat-dongman',
  },
  {
    slug: 'shaocr',
    name: '少儿',
    description: '寓教于乐的优质少儿内容，陪伴孩子快乐成长',
    icon: 'ri-heart-line',
    imageSeq: 'cat-shaocr',
  },
];

export const articles = [
  {
    id: 1,
    title: '《长安十二时辰》—— 古装悬疑剧的新标杆',
    slug: 'chang-an-shi-er-shi-chen',
    category: 'dianshiju',
    excerpt: '以唐代长安城为背景，讲述了一场惊心动魄的十二时辰反恐行动，精良的制作、扣人心弦的剧情，让这部剧成为近年来古装悬疑剧的巅峰之作。',
    content: `<p>《长安十二时辰》改编自马伯庸的同名小说，由曹盾执导，雷佳音、易烊千玺领衔主演。该剧以唐朝天宝三载为背景，讲述了上元节前夕，长安城混入可疑人员，死囚张小敬临危受命，与少年名士李必携手在十二时辰内破除隐患的故事。</p>
<p>剧中完美还原了唐代长安城的恢弘气象，无论是服饰、道具还是场景布置，都经过了严谨的历史考据。每一帧画面都如同一幅精美的唐代画卷，让观众仿佛穿越回了一千多年前的盛世长安。</p>
<p>在叙事层面，该剧采用了紧凑的48集篇幅来讲述24小时的故事，每集对应半个时辰，这种独特的时间叙事结构极大地增强了观众的代入感和紧张感。雷佳音饰演的张小敬粗中有细，易烊千玺饰演的李必少年老成，两人之间的化学反应为剧集增添了许多看点。</p>
<p>该剧播出后广受好评，豆瓣评分高达8.2分，被誉为"国产古装剧的里程碑之作"，不仅在国内引发追剧热潮，还在海外多个国家和地区播出，向世界展示了中国电视剧的制作水准。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20set%20in%20Tang%20Dynasty%20Changan%20city%2C%20ancient%20Chinese%20architecture%20with%20lanterns%20and%20crowded%20streets%20at%20night%2C%20cinematic%20lighting%2C%20epic%20historical%20atmosphere%2C%20high%20production%20value%20film%20photography%20with%20warm%20golden%20tones&width=1600&height=900&seq=article-changan&orientation=landscape',
    publishDate: '2025-12-15',
    author: '影视编辑部',
    tags: ['古装', '悬疑', '唐朝', '精品剧集'],
  },
  {
    id: 2,
    title: '《流浪地球3》—— 中国科幻电影的新高度',
    slug: 'liu-lang-di-qiu-3',
    category: 'dianying',
    excerpt: '作为中国科幻电影的标杆系列，《流浪地球3》以更加宏大的叙事和震撼的视觉效果，再次刷新了国产科幻电影的天花板。',
    content: `<p>《流浪地球3》延续了前两部的宏大叙事，讲述了人类在推动地球离开太阳系的过程中，遭遇了前所未有的宇宙危机。面对未知的挑战，全人类再次团结一致，用智慧和勇气书写了新的传奇。</p>
<p>影片在视觉效果上实现了质的飞跃，特效团队采用了最新的虚拟制作技术，打造出了令人叹为观止的太空场景。从行星发动机的壮观烈焰到浩瀚星河的深邃美丽，每一帧画面都彰显着中国电影工业的进步。</p>
<p>在故事层面，第三部更加注重人物情感的刻画。主线故事之外，多条人物线索交织，展现了普通人在末日危机下的选择与坚守。这种宏大叙事与个人情感的结合，让影片既有视觉冲击力，又有情感共鸣。</p>
<p>该片上映后首周票房突破30亿，打破多项国产电影纪录。国际媒体也给予了高度评价，认为该片标志着中国科幻电影已经具备了与世界一流科幻片比肩的实力。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20science%20fiction%20film%20scene%20with%20massive%20planet%20engines%20on%20a%20frozen%20Earth%20surface%2C%20giant%20blue%20plasma%20flames%20shooting%20into%20space%2C%20starships%20and%20space%20station%20in%20orbit%2C%20cinematic%20sci-fi%20aesthetic%2C%20dramatic%20cosmic%20lighting&width=1600&height=900&seq=article-wandering&orientation=landscape',
    publishDate: '2025-11-20',
    author: '电影频道',
    tags: ['科幻', '巨制', '中国电影', '视觉效果'],
  },
  {
    id: 3,
    title: '《声生不息》—— 用音乐传承华语经典',
    slug: 'sheng-sheng-bu-xi',
    category: 'zongyi',
    excerpt: '这档音乐综艺节目以"传承"为主题，邀请两岸三地实力歌手重新演绎华语经典歌曲，唤起几代人的音乐记忆。',
    content: `<p>《声生不息》是一档以华语金曲为核心的音乐竞演节目，节目邀请来自不同年代的实力歌手，用全新的编曲和演绎方式重新诠释那些陪伴几代人成长的经典歌曲。</p>
<p>节目最大的亮点在于"传承"二字。舞台上，老一辈歌手与新生代音乐人同台献唱，经典旋律在新时代的编曲中焕发新生。这种跨越年代的对话，不仅展现了华语音乐的深厚底蕴，也传递了音乐代代相传的美好寓意。</p>
<p>每一期节目的选曲都经过精心策划，从邓丽君的《月亮代表我的心》到Beyond的《海阔天空》，从周杰伦的《青花瓷》到五月天的《倔强》，涵盖了华语流行音乐各个时期的代表作。全新的编曲赋予了这些歌曲新的生命力，让年轻观众也能感受到经典的魅力。</p>
<p>该节目播出后收视率持续走高，全网话题阅读量超过百亿。许多观众表示，在看节目的过程中数次落泪，因为那些旋律唤起了他们最珍贵的青春回忆。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Grand%20music%20stage%20with%20Chinese-style%20stage%20design%2C%20colorful%20concert%20lighting%20and%20spotlights%2C%20singers%20performing%20on%20a%20beautiful%20stage%20with%20orchestra%2C%20atmospheric%20concert%20photography%20with%20warm%20and%20vibrant%20colors&width=1600&height=900&seq=article-shengsheng&orientation=landscape',
    publishDate: '2025-10-08',
    author: '综艺频道',
    tags: ['音乐', '经典', '综艺', '传承'],
  },
  {
    id: 4,
    title: '《航拍中国》第四季 —— 俯瞰壮美山河',
    slug: 'hang-pai-zhong-guo-4',
    category: 'jilupian',
    excerpt: '以空中视角俯瞰中国，从青藏高原到江南水乡，从长城内外到南海碧波，一部用镜头书写的地理诗篇。',
    content: `<p>《航拍中国》第四季继续以全航拍的独特视角，带领观众从空中俯瞰中国各地的自然风光与人文景观。本季涵盖西藏、青海、宁夏、广西等多个省区，展现了中国地理风貌的极致多样性。</p>
<p>节目制作历时两年，航拍团队跋涉数万公里，在海拔5000米以上的青藏高原、在茫茫戈壁荒漠、在热带雨林深处，用最先进的航拍设备记录下了许多从未被镜头捕捉过的壮丽画面。</p>
<p>每一帧画面都经得起放大细看——雪山之巅的纹理、河流蜿蜒的曲线、梯田层叠的韵律，这些细节构成了大地的视觉诗篇。配合精心制作的旁白解说，观众不仅能欣赏到视觉盛宴，还能深入了解各地的地理特征和人文故事。</p>
<p>该片在国内外均获得极高评价，被誉为"最美中国地理教科书"。许多观众表示，看完之后对中国的地理多样性有了全新的认识，也更加热爱自己生活的这片土地。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Aerial%20photography%20of%20stunning%20Chinese%20landscape%20with%20terraced%20rice%20fields%20and%20winding%20rivers%20in%20golden%20sunset%20light%2C%20misty%20mountains%20in%20distance%2C%20drone%20photography%20style%2C%20breathtaking%20natural%20scenery%20with%20warm%20earthy%20tones&width=1600&height=900&seq=article-aerial&orientation=landscape',
    publishDate: '2025-09-15',
    author: '纪录片频道',
    tags: ['航拍', '地理', '自然', '人文'],
  },
  {
    id: 5,
    title: '《大江大河3》—— 改革浪潮中的奋斗者群像',
    slug: 'da-jiang-da-he-3',
    category: 'dianshiju',
    excerpt: '延续前两部的精良制作，第三部聚焦90年代深化改革时期，三位主人公在时代浪潮中各自前行的动人故事。',
    content: `<p>《大江大河3》是"大江大河"系列的第三部，该剧延续了前两部的现实主义风格，以宋运辉、雷东宝、杨巡三位主人公的命运变迁，折射出90年代中国深化改革开放的宏大时代背景。</p>
<p>第三部中，三位主人公面临着全新的挑战：宋运辉在国企改革中遭遇阻力，雷东宝带领村民探索新的致富道路，杨巡在市场经济中跌宕起伏。他们的个人命运与国家改革的进程紧密交织，展现了一幅生动的时代画卷。</p>
<p>该剧在制作上精益求精，场景还原度极高，从工厂车间到农村田野，从简陋的办公室到初具规模的民营企业，每一个细节都准确还原了90年代的时代风貌。演员们的表演也极为出色，将角色的内心挣扎与成长刻画得入木三分。</p>
<p>《大江大河3》播出后引发了广泛的社会讨论，许多50后、60后观众表示在剧中看到了自己年轻时的影子。年轻观众也通过这部剧理解了父辈们奋斗的不易，形成了跨越代际的情感共鸣。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20realistic%20drama%20set%20in%201990s%20China%2C%20factory%20workers%20in%20workshop%20with%20industrial%20machinery%2C%20warm%20nostalgic%20lighting%2C%20period%20Chinese%20industrial%20setting%20with%20steam%20and%20steel%2C%20cinematic%20photography&width=1600&height=900&seq=article-dajiang&orientation=landscape',
    publishDate: '2025-08-22',
    author: '影视编辑部',
    tags: ['年代剧', '改革开放', '现实主义', '精品剧集'],
  },
  {
    id: 6,
    title: '《哪吒之魔童闹海》—— 国漫的又一次飞跃',
    slug: 'ne-zha-2',
    category: 'dongman',
    excerpt: '时隔五年，哪吒再度归来。这部续作在视觉效果、故事深度和情感表达上全面升级，为国漫树立了新的标杆。',
    content: `<p>《哪吒之魔童闹海》是2019年现象级动画电影《哪吒之魔童降世》的续作，讲述了哪吒与敖丙在经历了天劫之后，面对新的危机和挑战的故事。影片在传承中国传统文化的同时，赋予了角色更加现代化的精神内核。</p>
<p>在视觉层面，影片采用了全新的渲染技术，画面质感大幅提升。无论是人物的毛发细节、皮肤的质感，还是法术特效的绚丽程度，都达到了国际一流水平。特别是海底龙宫的场景设计，融合了中国传统美学与现代科技，营造出令人叹为观止的视觉效果。</p>
<p>故事层面，续作更加注重角色的成长与内心挣扎。哪吒不再仅仅是"我命由我不由天"的反叛少年，而是在经历了成长之后，开始思考责任与担当。这种角色弧光的深化让影片的情感层次更加丰富。</p>
<p>该片上映后不仅在国内取得惊人票房，在海外市场也获得了广泛好评，被多家国际媒体评为"年度最佳动画电影"的有力竞争者。这标志着中国动画电影已经具备了与国际顶级动画公司同台竞技的实力。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20film%20style%2C%20mythological%20Chinese%20character%20with%20flowing%20red%20silk%20ribbons%20and%20fire%20effects%2C%20dramatic%20dynamic%20pose%20against%20stormy%20sky%2C%20epic%20cinematic%20lighting%20with%20Chinese%20ink%20painting%20aesthetic&width=1600&height=900&seq=article-nezha&orientation=landscape',
    publishDate: '2025-07-30',
    author: '动漫频道',
    tags: ['动画', '国漫', '神话', '电影'],
  },
  {
    id: 7,
    title: '《舌尖上的中国》第五季 —— 人间烟火最抚人心',
    slug: 'she-jian-5',
    category: 'jilupian',
    excerpt: '时隔多年，这部现象级美食纪录片再次回归，以更加细腻的镜头语言讲述食物背后的人间故事。',
    content: `<p>《舌尖上的中国》第五季在万众期待中回归，延续了前四季的高水准制作，以"一日三餐"为主线，通过食物这个最朴素的角度，讲述当代中国人的生活故事和情感世界。</p>
<p>本季在选题上更加注重小人物的故事，从西北戈壁滩上的牧羊人早餐到岭南水乡的深夜食堂，从东北雪乡的杀猪菜到西南山区的菌子宴，每一集都是一次深入中国饮食文化腹地的探索。节目组深入全国二十余个省份，记录了上百种地方特色美食及其背后的文化内涵。</p>
<p>摄影方面，本季采用了最新的微距和高速摄影技术，将食物烹饪过程中的美妙瞬间捕捉得淋漓尽致——油花在锅中跳跃、蒸汽在盖子上凝结、刀锋切过食材的纹理，这些细节构成了令人垂涎的视觉盛宴。</p>
<p>观众评价该片"有温度、有深度、有烟火气"，不仅让人口舌生津，更让人感受到中华饮食文化的博大精深和中国人对美好生活的不懈追求。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20cuisine%20photography%2C%20steaming%20hot%20traditional%20Chinese%20dishes%20on%20wooden%20table%2C%20warm%20kitchen%20lighting%2C%20close-up%20of%20cooking%20process%20with%20steam%20and%20aromatic%20spices%2C%20rustic%20Chinese%20kitchen%20setting&width=1600&height=900&seq=article-shejian&orientation=landscape',
    publishDate: '2025-06-18',
    author: '纪录片频道',
    tags: ['美食', '人文', '纪录片', '传统文化'],
  },
  {
    id: 8,
    title: '《王牌对王牌》第九季 —— 欢笑与感动继续',
    slug: 'wang-pai-9',
    category: 'zongyi',
    excerpt: '王牌家族再度集结，新一季节目在经典游戏环节的基础上全面升级，带来更多欢笑与惊喜。',
    content: `<p>《王牌对王牌》第九季延续了该系列一贯的欢乐风格，王牌家族原班人马悉数回归，同时邀请了更多重量级嘉宾加盟，为观众呈现了一场场精彩纷呈的综艺盛宴。</p>
<p>新一季在保留经典游戏环节的基础上，增加了更多创新的互动玩法。"你画我猜"、"传声筒"等经典环节进行了全面升级，规则更加有趣，惩罚也更加刺激。同时新增了"时空穿越"、"身份互换"等全新环节，让节目看点十足。</p>
<p>除了游戏环节的升级，新一季还增加了更多走心的内容。每期节目都会设置一个"真情时刻"，让嘉宾分享自己的心路历程和人生感悟，在欢笑之余也有感动的瞬间。这种"笑中带泪"的情感体验，正是《王牌对王牌》区别于其他综艺的核心魅力。</p>
<p>节目播出以来收视率稳居同时段第一，网络播放量超百亿，证明了这档老牌综艺依然拥有强大的生命力和观众基础。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20variety%20show%20stage%20with%20bright%20studio%20lights%2C%20celebrities%20playing%20fun%20games%20on%20stage%2C%20energetic%20and%20playful%20atmosphere%2C%20Chinese%20TV%20variety%20show%20production%20with%20vibrant%20set%20design&width=1600&height=900&seq=article-wangpai&orientation=landscape',
    publishDate: '2025-05-10',
    author: '综艺频道',
    tags: ['综艺', '游戏', '欢乐', '经典'],
  },
  {
    id: 9,
    title: '《熊出没·重启未来》—— 陪伴一代人成长的国民IP',
    slug: 'xiong-chu-mo-2025',
    category: 'shaocr',
    excerpt: '国民级动画IP最新力作，熊大熊二与光头强展开全新的冒险，寓教于乐，传递环保与友爱的正能量。',
    content: `<p>《熊出没·重启未来》是该系列的最新动画电影，讲述了熊大、熊二和光头强在一次意外中穿越到未来世界，发现森林已经消失，他们需要共同努力回到过去并改变未来的故事。</p>
<p>影片在保持系列一贯搞笑风格的同时，融入了更多关于环保和科技的主题思考。未来的世界中，科技高度发达但自然环境遭到了严重破坏，这一设定让孩子们在欢乐中意识到保护环境的重要性。</p>
<p>动画制作方面，本片采用了最新的渲染技术，画面质量有了显著提升。角色表情更加丰富自然，场景设计也更加宏大精美，特别是未来世界的城市设计和森林场景的对比，视觉效果令人印象深刻。</p>
<p>该片不仅深受小朋友喜爱，也获得了家长群体的高度认可。许多家长表示，影片中的环保主题和友情故事让孩子在看动画的同时也学到了宝贵的价值观。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Cute%20animated%20bears%20in%20a%20colorful%20forest%20setting%2C%20Chinese%20animation%20style%2C%20friendly%20bear%20characters%20with%20bright%20warm%20colors%2C%20playful%20childrens%20animation%20aesthetic%2C%20sunlit%20forest%20with%20flowers&width=1600&height=900&seq=article-xiongchumo&orientation=landscape',
    publishDate: '2025-04-25',
    author: '少儿频道',
    tags: ['动画', '少儿', '环保', '大电影'],
  },
  {
    id: 10,
    title: '《孤注一掷》—— 现实题材电影的力量',
    slug: 'gu-zhu-yi-zhi',
    category: 'dianying',
    excerpt: '改编自真实诈骗案例，这部影片以极具冲击力的叙事方式揭示了网络诈骗的残酷真相，引发全社会对反诈话题的关注。',
    content: `<p>《孤注一掷》取材自上万起真实诈骗案例，讲述了程序员潘生和模特安娜被高薪招聘诱骗至境外诈骗工厂后，在绝境中奋力自救的故事。影片以极具真实感的叙事方式，揭开了网络诈骗黑色产业链的面纱。</p>
<p>影片的拍摄手法独特而大胆。导演采用了大量的手持摄影和纪实风格的镜头语言，营造出令人窒息的紧张感和压迫感。诈骗窝点的场景设计极为逼真，阴暗潮湿的环境、密集的工位、24小时不间断的监控，每一个细节都让人不寒而栗。</p>
<p>演员们的表演也获得了广泛赞誉。主演们为了更好地诠释角色，深入了解了真实的诈骗案例和受害者经历，将角色在绝境中的恐惧、挣扎与勇气表现得淋漓尽致。特别是几场关键的情感爆发戏，被观众和影评人一致称为"教科书级别的表演"。</p>
<p>影片上映后引发了全社会的反诈热潮，各地公安机关纷纷借势开展反诈宣传。该片不仅是一部优秀的电影作品，更是一次成功的公共安全教育。影片最终以超过38亿的票房成绩，证明了现实题材电影的巨大市场潜力。</p>`,
    imageUrl: 'https://readdy.ai/api/search-image?query=Intense%20Chinese%20crime%20drama%20film%20scene%2C%20dimly%20lit%20room%20with%20computer%20screens%2C%20tense%20atmosphere%2C%20Chinese%20actors%20in%20dramatic%20confrontation%2C%20cinematic%20noir%20lighting%20with%20cool%20shadows%20and%20warm%20accents&width=1600&height=900&seq=article-guzhu&orientation=landscape',
    publishDate: '2025-03-12',
    author: '电影频道',
    tags: ['犯罪', '现实题材', '反诈', '社会话题'],
  },
];

export const faqItems = [
  {
    question: '国产精品在线提供哪些类型的内容？',
    answer: '国产精品在线汇聚海量正版高清国产内容，涵盖电视剧、电影、综艺、纪录片、动漫、少儿等六大品类，满足不同年龄段用户的多样化观影需求。所有内容均经过正版授权，确保品质和安全。',
  },
  {
    question: '如何在不同设备上观看内容？',
    answer: '国产精品在线支持多端流畅播放，您可以通过电脑浏览器、手机App、平板电脑以及智能电视等多种设备随时随地享受高清内容。只需一个账号，即可在所有设备间无缝切换，追剧不间断。',
  },
  {
    question: '平台上的内容是否需要付费？',
    answer: '国产精品在线采用灵活的会员体系，部分精彩内容可免费观看，VIP会员可享受全部内容无广告高清播放、独家内容抢先看、多端同步等专属权益。我们定期推出优惠活动，让更多用户以实惠价格享受优质内容。',
  },
  {
    question: '如何搜索和发现感兴趣的内容？',
    answer: '您可以通过首页搜索框直接搜索作品名称、演员或导演，也可以通过分类浏览、排行榜、智能推荐等多种方式发现感兴趣的内容。我们的智能推荐系统会根据您的观看历史和偏好，为您精准推荐可能喜欢的内容。',
  },
  {
    question: '平台的内容更新频率如何？',
    answer: '国产精品在线与国内各大内容制作方保持紧密合作，每日都有新内容上线。热播剧集通常与电视台同步更新，电影、综艺等内容也会在授权后第一时间上线，确保您不会错过任何精彩。',
  },
  {
    question: '如何联系客服或反馈问题？',
    answer: '您可以通过"关于我们"页面的联系方式与我们取得联系，或发送邮件至客服邮箱。我们的客服团队7×24小时在线，平均响应时间不超过5分钟，竭诚为您解决任何问题。',
  },
];

export const aboutInfo = {
  brandName: '国产精品在线',
  founded: '2018年',
  headquarters: '北京市朝阳区',
  mission: '汇聚优质国产内容，传承中华优秀文化，让每一位用户都能便捷地发现和享受正版高清的国产文化精品。',
  vision: '成为中国领先的正版国产内容聚合平台，推动国产文化内容的繁荣发展，让世界看到中国文化的魅力。',
  milestones: [
    { year: '2018', event: '平台正式上线，首批接入500+正版内容' },
    { year: '2019', event: '注册用户突破100万，内容库扩充至2000+' },
    { year: '2020', event: '推出智能推荐系统，提升用户内容发现体验' },
    { year: '2021', event: '上线多端同步功能，实现全设备无缝观看' },
    { year: '2022', event: '用户数突破1000万，成为行业领先平台' },
    { year: '2023', event: '推出4K超高清内容专区，提升观看品质' },
    { year: '2024', event: '开始国际化布局，内容出口至30+国家和地区' },
    { year: '2025', event: '总用户突破5000万，持续引领国产内容发展' },
  ],
  honors: [
    '国家文化出口重点企业',
    '中国互联网诚信示范单位',
    '年度最佳内容聚合平台',
    '数字文化创新企业奖',
    '用户最满意在线平台',
  ],
  contact: {
    email: 'service@guochangjingpin.com',
    phone: '400-888-9999',
    address: '北京市朝阳区建国路88号国贸大厦A座',
    wechat: '国产精品在线',
  },
};

export const featuredContent = [
  { id: 1, title: '长安十二时辰', category: '电视剧', rating: 9.2, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20poster%20style%2C%20Tang%20Dynasty%20detective%20in%20ancient%20Changan%20city%2C%20cinematic%20Chinese%20drama%20aesthetic%2C%20warm%20golden%20lighting%2C%20professional%20film%20poster&width=800&height=450&seq=feat-1&orientation=landscape' },
  { id: 2, title: '流浪地球3', category: '电影', rating: 9.0, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20science%20fiction%20film%20poster%20style%2C%20massive%20planet%20engine%20on%20frozen%20Earth%2C%20epic%20Chinese%20sci-fi%20movie%20aesthetic%2C%20dramatic%20cosmic%20lighting%2C%20professional%20film%20poster&width=800&height=450&seq=feat-2&orientation=landscape' },
  { id: 3, title: '声生不息', category: '综艺', rating: 8.8, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20music%20variety%20show%20poster%20style%2C%20singers%20on%20colorful%20stage%20with%20concert%20lighting%2C%20Chinese%20entertainment%20show%20aesthetic%2C%20vibrant%20music%20performance%2C%20professional%20poster&width=800&height=450&seq=feat-3&orientation=landscape' },
  { id: 4, title: '航拍中国·第四季', category: '纪录片', rating: 9.5, imageUrl: 'https://readdy.ai/api/search-image?query=Aerial%20photography%20Chinese%20documentary%20poster%20style%2C%20stunning%20Chinese%20landscape%20with%20terraced%20fields%2C%20drone%20photography%20aesthetic%2C%20warm%20golden%20sunset%20lighting%2C%20professional%20documentary%20poster&width=800&height=450&seq=feat-4&orientation=landscape' },
  { id: 5, title: '哪吒之魔童闹海', category: '动漫', rating: 9.3, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%20style%2C%20mythological%20Chinese%20character%20with%20fire%20effects%2C%20epic%20Chinese%20animation%20aesthetic%2C%20dramatic%20dynamic%20lighting%2C%20professional%20animation%20poster&width=800&height=450&seq=feat-5&orientation=landscape' },
  { id: 6, title: '大江大河3', category: '电视剧', rating: 8.9, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20realistic%20drama%20poster%20style%2C%201990s%20China%20factory%20workers%2C%20period%20Chinese%20drama%20aesthetic%2C%20warm%20nostalgic%20lighting%2C%20professional%20TV%20drama%20poster&width=800&height=450&seq=feat-6&orientation=landscape' },
  { id: 7, title: '舌尖上的中国·第五季', category: '纪录片', rating: 9.1, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20style%2C%20steaming%20traditional%20Chinese%20dishes%2C%20Chinese%20culinary%20arts%20aesthetic%2C%20warm%20kitchen%20lighting%2C%20professional%20documentary%20poster&width=800&height=450&seq=feat-7&orientation=landscape' },
  { id: 8, title: '熊出没·重启未来', category: '少儿', rating: 8.5, imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20children%20animation%20poster%20style%2C%20cute%20animated%20bears%20in%20colorful%20forest%2C%20Chinese%20kids%20animation%20aesthetic%2C%20bright%20sunlit%20scene%2C%20professional%20animation%20poster&width=800&height=450&seq=feat-8&orientation=landscape' },
];

export const hotRanking = [
  { rank: 1, title: '长安十二时辰', category: '电视剧', hot: 9856 },
  { rank: 2, title: '流浪地球3', category: '电影', hot: 9342 },
  { rank: 3, title: '哪吒之魔童闹海', category: '动漫', hot: 8976 },
  { rank: 4, title: '声生不息', category: '综艺', hot: 8521 },
  { rank: 5, title: '航拍中国·第四季', category: '纪录片', hot: 8234 },
  { rank: 6, title: '大江大河3', category: '电视剧', hot: 7890 },
  { rank: 7, title: '舌尖上的中国·第五季', category: '纪录片', hot: 7543 },
  { rank: 8, title: '孤注一掷', category: '电影', hot: 7210 },
];